import Renderable from '../renderable'

buildHashUrl = (params) ->
  remaining = params.toString()
  location.pathname + location.search + (if remaining then "##{remaining}" else "")

# Editors share i18n scoping and the URL-hash helpers; each owns one hash
# slice (playbook editor → `scene`, scene editor → `action`/`ref`).
export default class EditorBase extends Renderable
  @i18nScopeNamespace = "editor"

  # Override to own a hash slice; gets wired to hashchange automatically.
  onLocationHashChange: null

  constructor: ->
    super()

    return unless @onLocationHashChange

    @_locationHashListener = => @onLocationHashChange()
    window.addEventListener "hashchange", @_locationHashListener

    # Deferred: subclass state the loader reads is not set until after super().
    queueMicrotask => @_locationHashListener?()

  teardownLocationHash: ->
    return unless @_locationHashListener

    window.removeEventListener "hashchange", @_locationHashListener
    @_locationHashListener = null

  hashParams: -> new URLSearchParams(location.hash.replace(/^#/, ""))

  # Several params in one history entry; null deletes a key. No-op when the
  # hash already matches, so restating it adds no entry.
  updateHashParams: (updates, {replace = false} = {}) ->
    params = @hashParams()
    changed = false

    for own key, value of updates
      if value?
        params.set(key, value)
      else if params.has(key)
        params.delete(key)

    url = buildHashUrl(params)

    historyFunc = history[if replace then "replaceState" else "pushState"]
    historyFunc.call(history, null, "", url)
